import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  DocumentsList,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../components";
import {
  BasisOfH1B,
  H1BStatus,
  WADocStatus,
} from "../../../../../assets/data/enumData";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { filterEmptyValues } from "../../../../../utils/filterEmptyValues";
import { useDispatch } from "react-redux";
import { uploadStart } from "../../../../../redux/slices/universal/fileUploadSlice";
import { addNewImmigrationsStart } from "../../../../../redux/slices/immigration/immigrationSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { v4 as uuidv4 } from "uuid";
import { BiChip } from "react-icons/bi";
const AddH1B = ({
  isEditMode = false,
  initialData = {},
  onSave,
  onCancel,
  handleBack,
  editData = null,
}) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const [attachmentModal, setAttachmentModal] = useState(false);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        hOneBStatus: "",
        employeeId: "",
        receiptNumber: "",
        processingType: 1,
        basisOfH1B: "",
        lcas: "",
        priority: "",
        recordStatus: "",
        expiryDate: "",
        attachment: [],
        comments: "",
        ...initialData, // Prefill when editing
      },
      {
        hOneBStatus: { type: "number", required: true },
        employeeId: { type: "number", required: true },
        receiptNumber: { required: true },
        processingType: { type: "number", required: true },
        basisOfH1B: { required: true },
        lcas: { type: "select", required: true },
        priority: { required: true },
        recordStatus: { required: true },
        expiryDate: { type: "date", required: true },
        attachment: { type: "file", required: true },
      }
    );
  const [lcaList, setLcaList] = useState([]);
  const handleCallLcaList = async (value) => {
    try {
      const filter = {
        employeeId: { type: "NONE", value: value?.value ?? value },
        endDate: { type: "GTE", value: new Date() },
      };
      const reponse = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.LCA.GET_ALL,
        params: {
          coll: "LCA",
          fil: JSON.stringify(filter),
          ret: "uiid number endDate",
        },
      });
      if (reponse?.success) {
        const filterDatesActive = reponse?.data?.data?.filter(
          (data) => new Date(data.endDate) > new Date()
        );
        const lcaNumbersOptions = filterDatesActive.map((data) => ({
          label: data.number,
          value: data.uiid,
        }));
        setLcaList(lcaNumbersOptions);
      } else {
        setLcaList([]);
      }
      console.log("reponse", reponse);
    } catch (error) {}
  };

  //   useEffect(() => {
  //     if (isEditMode && initialData) {
  //       setFormData(initialData);
  //     }
  //   }, [isEditMode, initialData, setFormData]);

  const handleSubmit = () => {
    const isValid = validateAllFields();
    if (isValid) {
      // onSave?.(formData);
      const h1b = {
        // type: formData.processingType,
        status: formData.hOneBStatus,
        employeeId: formData.employeeId?.value ?? formData?.employeeId,
        expiryDate: formData.expiryDate,
        receiptNum: formData.receiptNumber,
        processType: formData.processingType,
        lcas: formData.lcas,
        priority: formData.priority,
        recordStatus: formData.recordStatus,
        comments: formData.comments,
        filedOn:new Date(),
        type:formData.basisOfH1B,
      };
      const cleanAttachments =
        Array.isArray(formData.attachment) && formData.attachment.length > 0
          ? formData.attachment.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      const submissionData = filterEmptyValues(h1b);
      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: formData.employeeId?.value ?? formData?.employeeId,
            entity: "h1bs",
            category: "h1bs",
            coll: "H1B",
            doc: cleanAttachments,
            onSuccess: async (fileData) => {
              const attachment = cleanAttachments.flatMap((data) =>
                fileData
                  .filter((file) => file.fileRefId === data.id)
                  .map((file) => file.key)
              );
              dispatch(
                addNewImmigrationsStart({
                  uiid: editData?.uiid || "",
                  coll: "H1B",
                  rsn: "h1b",
                  rsd: submissionData,
                  payload: editData?.uiid
                    ? [
                        {
                          type: "SET",
                          value: {
                            ...submissionData,
                            documents: attachment,
                          },
                        },
                      ]
                    : {
                        addedBy: loginUserUiid,
                        ...submissionData,
                        documents: attachment,
                      },
                  onSuccess: async (payload) => {
                    handleBack();
                  },
                })
              );
            },
          })
        );
      } else {
      }
    } else {
      showToast("Please fill all required fields to proceed.", "error");
    }
  };
  const combineAttachments = (editData?.documents || []).map((data) => ({
    filePath: data,
    name: "H1B",
  }));
  
    useEffect(() => {
   if(editData&&isEditMode){
        setFormData({
          hOneBStatus: editData.status || "",
          receiptNumber: editData.receiptNum || "",
          processingType: editData.processType || "Premium",
          lcas: editData.lcas || "",
          priority: editData.priority || "",
          recordStatus: editData.recordStatus || "",
          expiryDate: editData.expiryDate || "",
          attachment: editData.attachment || [],
          comments: editData.comments || "",
          basisOfH1B: editData.type || "",
          employeeId: editData?.employeeId?.uiid??editData?.employeeId,
        });
        handleCallLcaList(editData?.employeeId?.uiid??editData?.employeeId)
      }
    }, [editData, setFormData]);
  return (
    <div className="pt-2">
      <PageHeader
        Section={
          <div className="flex items-center gap-2">
            <Button
              // type="icon"
              variant="text"
              icon="arrow_left_alt"
              color="black"
              title={isEditMode ? "Edit H-1B" : "Add H-1B"}
              onClick={handleBack}
              className="pl-0!"
            />
            {/* <PageTitle title={isEditMode ? "Edit H-1B" : "Add H-1B"} tag="p" /> */}
          </div>
        }
      />

      <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-4 mt-5">
        {!isEditMode && (
          <FormFieldSet
            type="employees"
            title="Employee Name"
            placeholder="Enter Employee Name"
            value={formData.employeeId}
            onChange={(value) => {
              handleChange("employeeId", value);
              handleCallLcaList(value);
            }}
            error={errors.employeeId}
            // disabled={isEdit}
            showSearch
          />
        )}

        <FormFieldSet
          type="select"
          title="H-1B Status"
          placeholder="Select Status"
          value={formData.hOneBStatus}
          onChange={(value) => handleChange("hOneBStatus", value)}
          error={errors.hOneBStatus}
          options={H1BStatus}
        />

        <FormFieldSet
          type="text"
          title="Receipt Number"
          placeholder="Enter Receipt Number"
          value={formData.receiptNumber}
          onChange={(value) => handleChange("receiptNumber", value)}
          error={errors.receiptNumber}
        />

        <FormFieldSet
          type="radio"
          title="Processing Type"
          options={[
            { label: "Premium", value: 1 },
            { label: "Normal", value: 2 },
          ]}
          value={formData.processingType}
          onChange={(event) =>
            handleChange("processingType", parseInt(event.target.value))
          }
          name="processingType"
        />

        <FormFieldSet
          type="select"
          title="Basis of H-1B"
          placeholder="Select Basis"
          value={formData.basisOfH1B}
          onChange={(value) => handleChange("basisOfH1B", value)}
          error={errors.basisOfH1B}
          options={BasisOfH1B}
        />

        <FormFieldSet
          type="select"
          title="LCA(s)"
          placeholder="Select LCA"
          value={formData.lcas}
          onChange={(value) => handleChange("lcas", value)}
            error={errors.lcas}
         options={lcaList || []}
        />

        <FormFieldSet
          type="select"
          title="Priority"
          placeholder="Select Priority"
          value={formData.priority}
          onChange={(value) => handleChange("priority", value)}
          error={errors.priority}
          options={[
            { label: "High", value: 1 },
            { label: "Medium", value: 2 },
            { label: "Low", value: 3 },
          ]}
        />

        <FormFieldSet
          type="select"
          title="Record Status"
          placeholder="Select Status"
          value={formData.recordStatus}
          onChange={(value) => handleChange("recordStatus", value)}
          error={errors.recordStatus}
          options={WADocStatus}
        />

        <FormFieldSet
          type="datepicker"
          title="Expiry Date"
          placeholder="Select Expiry Date"
          value={formData.expiryDate}
          onChange={(value) => handleChange("expiryDate", value)}
          error={errors.expiryDate}
          showDropdown={false}
        />

        <FormFieldSet
          type="file"
          title="Attachment"
          placeholder="Choose File"
          value={formData.attachment}
          onChange={(value) => handleChange("attachment", value)}
          error={errors.attachment}
          multiple
        />
        {editData&&(
 <div
          className=" flex rounded-md items-center cursour-pointer"
          onClick={() => setAttachmentModal(!attachmentModal)}
        >
          <Chip
            label={`Attachments:-${combineAttachments.length}`}
            icon={"docs"}
            iconPosition={"before"}
          />
        </div>
        )}
       
        <FormFieldSet
          type="textArea"
          title="Comments"
          placeholder="Enter Comments"
          value={formData.comments}
          onChange={(value) => handleChange("comments", value)}
          error={errors.comments}
        />
      </div>

      <div className="flex gap-2 justify-end mt-8">
        <Button title="Cancel" variant="outlined" onClick={handleBack} />
        <Button
          title={isEditMode ? "Update" : "Save & Proceed"}
          onClick={handleSubmit}
        />
      </div>
      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={combineAttachments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
    </div>
  );
};

export default AddH1B;
